<template>
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 60px;text-align:left">
        <b-row style="width:100vw;">

        <b-col col cols="12" sm="4" offset-sm="4" md="4" offset-md="4" lg="4" offset-lg="4" style="overflow-y:auto;text-align:left !important;"
        class="shadow-lg p-3 mb-5 bg-white rounded cardHeight">
        <b-col col cols="4" sm="4" md="4" lg="4" offset-sm="4" offset-md="4" offset-lg="4">
          <b-img class="logo" src="../assets/apdcl_logo.png" fluid   alt="logo"></b-img>
        </b-col>
        <br>
        <b-row>
          <b-col col cols="12" sm="12" md="12" lg="12">
            <h1 align="center" style="text-align:center;color:#303f9f;font-size:1.5rem;">APDCL Portal Admin</h1>
          </b-col>
        </b-row>
        <br>
          <b-input-group class="mb-2" style="width:100%;">
            <b-input-group-prepend is-text>
              <b-icon icon="person-fill"></b-icon>
            </b-input-group-prepend>
            <b-form-input type="text" id="userIdAdmin" v-model="userIdAdmin"   placeholder="User ID"></b-form-input>
          </b-input-group>
          <br><br>
          <b-input-group class="mb-2" style="width:100%;">
            <b-input-group-prepend is-text>
              <b-icon icon="lock-fill"></b-icon>
            </b-input-group-prepend>
            <b-form-input type="password" id="passwordAdmin" v-model="passwordAdmin" autocomplete="off" placeholder="Password"></b-form-input>
          </b-input-group>
          <br><br>
          <b-row>
            <b-col cols="12" offset="">

                  <b-button block  id="logInAdminBtn1" @click="loginAdmin()" variant="primary">Log In</b-button>

            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
   <br><br>
   </b-overlay>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'

//var urlCommon = "https://portald.apdcl.org/website";
//var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data(){
    return{
      userIdAdmin: '',
      passwordAdmin: '',
      show: false
    }
  },
  methods:
  {
    loginAdmin(){
      var user = this.userIdAdmin;
      var pw = this.passwordAdmin;
       if(user == ""){
          this.$bvToast.toast('User Id can not be empty !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
          return
        }
        if(pw == ""){
          this.$bvToast.toast('Password can not be empty !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
          return
        }

      var FormData = require('form-data');
      var formData = new FormData();
      formData.append('username', user);
      formData.append('password', pw);

      for (var value of formData.values()) {
         console.log(value);
      }

      // uncomment the line and call respective API
      var parent = this;
      parent.show=true;
      axios.post(this.$urlCommon+"/login", formData).then(function(response) {
      parent.show=false;
      console.log(response.data)
      var urlToRedirect = response.data.url;
      console.log("path:"+urlToRedirect);
	  var JSESSIONID = response.data.sessionId;
	  localStorage.setItem("JSESSIONID", JSESSIONID);
    var data=response.data;

    localStorage.setItem("roleSet", data.roleList);
  //  localStorage.setItem("userName", data.userName);
  //    localStorage.setItem("userId", data.userId);

	  parent.$router.push({ path: urlToRedirect })
	  });
    },

  },
  mounted()
  {

  }

}


</script>

<style scoped="true">
body{
  overflow-y:hidden !important;
}
.menuCol
{
 display:none;
}
.menuItem
{
  border-radius: 50%;
  height:10rem;
  width:10rem;
  margin-top:1rem;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #6a1b9a ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}

.cardHeight{
  height:78vh;
}

@media screen and (max-width: 2560px) and (min-width: 1441px) {
  .cardHeight{
    height:50vh;
  }
}

@media screen and (max-width: 1440px) and (min-width: 1025px) {
  .cardHeight{
    height:78vh;
  }
}

@media screen and (max-width: 1024px) and (min-width: 769px) {
  .cardHeight{
    height:78vh;
  }
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
    .cardHeight{
      height:82vh;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
</style>
